import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@heroui/react';
import { useEffect, useState } from 'react';
import { api } from './api';
import Conversation, { ConversationMessage } from './components/conversation';

export type Message = {
  createdAt: string;
  author: 'user' | 'system';
  text: string;
};

const items = [
  {
    key: 'simple-chat',
    label: 'GPT Chat',
  },
  {
    key: 'rag-chat',
    label: 'Rag Chat',
  },
];

const Home = () => {
  const [chatId, setChatId] = useState('');
  const [chatHistory, setChatHistory] = useState<ConversationMessage[]>([]);

  useEffect(() => {
    const loadChatHistory = async (chatId: string) => {
      try {
        const response: Message[] = await api.get('/api/history?chatId=' + chatId);
        setChatHistory(
          response.map((item) => ({
            role: item.author,
            message: item.text,
          })) || [],
        );
      } catch {
        console.log('Failed to fetch chat history');
      }
    };

    const chatId = window.localStorage.getItem('Q_AI_CHAT_ID');
    if (!chatId) {
      onStartNewConversation();
    } else {
      setChatId(chatId);
      loadChatHistory(chatId);
    }
  }, []);

  const onStartNewConversation = (chatType: 'rag-chat' | 'simple-chat' = 'simple-chat') => {
    const createChat = async () => {
      try {
        const response = await (api.post('/api/chat', {
          executor: chatType,
        }) as Promise<{ chatId: string }>);
        const resultChatId = response ? response.chatId : '';
        setChatId(resultChatId);
        window.localStorage.setItem('Q_AI_CHAT_ID', resultChatId);
      } catch {
        console.log('Failed to fetch chatId');
      }
    };
    setChatHistory([]);
    setChatId('');
    createChat();
  };

  return (
    <div className={'flex h-full w-full max-w-full flex-col gap-8'}>
      <div className="flex gap-2">
        <Dropdown>
          <DropdownTrigger>
            <Button color="primary" variant="flat" className="flex-shrink-0">
              Start new conversation
            </Button>
          </DropdownTrigger>
          <DropdownMenu aria-label="Dynamic Actions" items={items}>
            {(item) => (
              <DropdownItem
                key={item.key}
                className={item.key === 'delete' ? 'text-danger' : ''}
                color={item.key === 'delete' ? 'danger' : 'default'}
                onPress={() => onStartNewConversation(item.key as 'rag-chat' | 'simple-chat')}
              >
                {item.label}
              </DropdownItem>
            )}
          </DropdownMenu>
        </Dropdown>
      </div>
      <Conversation chatId={chatId} messagesHistory={chatHistory} />
    </div>
  );
};

export default Home;
